import { motion } from "framer-motion";
import { CircleArrowRight } from "lucide-react";
import Lightfall from "@/components/Lightfall";

const PageHero = ({ title, crumbs, lightfall }) => (
  <section data-testid="page-hero" className="relative bg-miti-navy pt-40 pb-32 hero-grain overflow-hidden">
    {lightfall ? (
      <div className="absolute inset-0">
        <Lightfall
          colors={["#A6C8FF", "#5227FF", "#FF9FFC"]}
          backgroundColor="#0A29FF"
          speed={0.5}
          streakCount={2}
          streakWidth={1}
          streakLength={1}
          density={0.6}
          twinkle={1}
          glow={1}
          backgroundGlow={0.5}
          zoom={3}
          opacity={1}
          mouseInteraction
          mouseStrength={0.5}
          mouseRadius={1}
        />
      </div>
    ) : (
      <div className="absolute inset-0 opacity-50">
        <div className="absolute -top-24 -right-24 w-[500px] h-[500px] rounded-full bg-miti-blue/30 blur-[140px]" />
        <div className="absolute -bottom-32 -left-24 w-[400px] h-[400px] rounded-full bg-sky-400/20 blur-[120px]" />
      </div>
    )}
    <div className="relative max-w-7xl mx-auto px-6 lg:px-10 text-center">
      <motion.nav
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="flex items-center justify-center gap-2.5 text-sm text-slate-300"
        data-testid="page-breadcrumb"
      >
        {crumbs.map((c, i) => (
          <span key={c.label} className="flex items-center gap-2.5">
            {i > 0 && <CircleArrowRight size={16} className="text-sky-400" />}
            {c.href ? (
              <a
                href={c.href}
                data-testid={`breadcrumb-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="hover:text-white transition-colors"
              >
                {c.label}
              </a>
            ) : (
              <span className="text-white font-medium">{c.label}</span>
            )}
          </span>
        ))}
      </motion.nav>
      <motion.h1
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="mt-6 font-heading font-bold tracking-tight text-4xl sm:text-5xl lg:text-6xl text-white"
      >
        {title}
      </motion.h1>
    </div>
    <svg
      viewBox="0 0 1000 100"
      preserveAspectRatio="none"
      aria-hidden="true"
      className="absolute bottom-0 left-0 w-full h-14 sm:h-20 fill-white"
    >
      <path d="M500,97C126.7,96.3,0.8,19.8,0,0v100l1000,0V1C1000,19.4,873.3,97.8,500,97z" />
    </svg>
  </section>
);

export default PageHero;
